import styled from 'styled-components';
import { BorderRadiusMedium, Spacing16 } from 'autogen/design-tokens/tokens';
import type { HeadlineProps, IMenuSection } from 'components/generic/menu/shared/types';
import { Typography } from 'components/generic/typography';
import List from 'components/List';
import { MenuSection, MenuSectionHeader } from '../shared/styling';

export const DefaultMenuSectionHeadline = (headlineProps: HeadlineProps) => {
    return (
        <MenuSectionHeader size={headlineProps.size}>
            <Typography.Body as="span" size="L" strong>
                {headlineProps.headline}
            </Typography.Body>
        </MenuSectionHeader>
    );
};

export default function DefaultMenuSection({
    size,
    headline,
    headlineRenderer = DefaultMenuSectionHeadline,
    headlineOutsideSection,
    listProps,
    children,
    ...restProps
}: IMenuSection) {
    return (
        <>
            {headline && headlineOutsideSection && headlineRenderer({ headline, size })}
            <MenuSection size={size} {...restProps}>
                {headline && !headlineOutsideSection && headlineRenderer({ headline, size })}
                <List {...listProps}>{children}</List>
            </MenuSection>
        </>
    );
}

const StyledSecondaryMenuSection = styled(DefaultMenuSection)`
    position: relative;
    background-color: ${({ theme }) => theme.ColorBackgroundSecondary};
`;

export function SecondaryMenuSection({ children, ...restProps }: IMenuSection) {
    return <StyledSecondaryMenuSection {...restProps}>{children}</StyledSecondaryMenuSection>;
}

const StyledSecondaryMenuSectionWithDividers = styled(SecondaryMenuSection)`
    
`;

export function SecondaryMenuSectionWithDividers({ children, ...restProps }: IMenuSection) {
    return <StyledSecondaryMenuSectionWithDividers {...restProps}>{children}</StyledSecondaryMenuSectionWithDividers>;
}

const StyledBoxedMenuSection = styled(DefaultMenuSection)`
    border-radius: ${BorderRadiusMedium};
    border-bottom: none;
    padding: 0;
    margin: 0 ${Spacing16} ${Spacing16};
    overflow: hidden;
`;

export function BoxedMenuSection({ children, ...restProps }: IMenuSection) {
    return <StyledBoxedMenuSection {...restProps}>{children}</StyledBoxedMenuSection>;
}
